import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";

import {
  useGetProductsQuery,
  usePutProductMutation,
} from "../../../../features/Inventory/product/productApiSlice";

import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../../features/auth/authSlice";

import CountUp from "react-countup";
import { CSVLink } from "react-csv";
import { notifyError, notifySuccess } from "../../../../helpers/Notify";

import { IMAGES } from "../../../constant/theme";

const cardCounter = [
  { number: "8", countText: "primary", title: "Not Started" },
  { number: "7", countText: "purple", title: "In Progress" },
  { number: "13", countText: "warning", title: "Testing" },
  { number: "11", countText: "danger", title: "Cancelled" },
  { number: "21", countText: "success", title: "Complete" },
  { number: "16", countText: "danger", title: "Pending" },
];

const Product = () => {
  const [putProduct, { isLoading, isError, error }] = usePutProductMutation();
  const { data: products = [], refetch } = useGetProductsQuery();

  useEffect(() => {
    refetch();
  }, []);
  // const csvlink = {
  //   headers: headersTitle,
  //   data: products?.products,
  //   filename: "csvfile.csv",
  // };
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const [search, setSearch] = useState("");
  const userInfo = useSelector(selectCurrentUser);
  const recordsPage = 13;
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;

  const filterProducts = () => {
    if (!search) return products?.products;

    return products?.products?.filter((product) => {
      const productName = product?.name?.toLowerCase();
      const brand = product?.brand?.name?.toLowerCase();
      const category = product?.category?.name?.toLowerCase();
      const price = product?.price?.toString().toLowerCase();
      const quantity = product?.quantity?.toString().toLowerCase();
      const date = new Date(product?.createdAt).toLocaleString().toLowerCase();

      return (
        productName.includes(search.toLowerCase()) ||
        brand.includes(search.toLowerCase()) ||
        category.includes(search.toLowerCase()) ||
        price.includes(search.toLowerCase()) ||
        quantity.includes(search.toLowerCase()) ||
        date.includes(search.toLowerCase())
      );
    });
  };

  const filteredProducts = filterProducts();
  const totalCost = filteredProducts?.reduce(
    (sum, product) => sum + product?.price * product?.quantity,
    0
  );
  const totalQuantity = filteredProducts?.reduce(
    (sum, product) => sum + product?.quantity,
    0
  );
  // Calculate average cost per unit
  const averageCostPerUnit = totalQuantity > 0 ? totalCost / totalQuantity : 0;
  const records = filteredProducts?.slice(firstIndex, lastIndex);
  const npage = Math.ceil((filteredProducts?.length || 0) / recordsPage);
  const number = [...Array(npage + 1).keys()].slice(1);

  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    setCurrentPage(id);
  }
  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }

  const [statusPriority, setStatusPriority] = useState(records);

  const handleDelete = (product) => {
    let updatedProduct = { ...product };
    updatedProduct.isDeleted = true;

    putProduct({ id: updatedProduct?.productId, updatedProduct })
      .unwrap()
      .then((response) => {
        notifySuccess("Product deleted successfully");
        refetch();
        navigate("product");
      })
      .catch((error) => {
        console.error("Error updating product", error);
      });
  };

  const handleEdit = (product) => {
    navigate("edit/" + product?.productId);
  };

  const handleView = (product) => {
    navigate("view/" + product?.productId);
  };

  const [unchecked, setUnChecked] = useState(true);
  const handleChecked = (id) => {
    let temp = statusPriority.map((data) => {
      if (id === data.id) {
        return { ...data, inputchecked: !data.inputchecked };
      }
      return data;
    });
    setStatusPriority(temp);
  };

  const SweetAlert = (product) =>
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        handleDelete(product);
      } else {
        swal("Your data is safe!");
      }
    });
  const headersTitle = [
    { label: "#", key: "index" },
    { label: "Product Name", key: "name" },
    { label: "Brand", key: "brand.name" },
    { label: "Category", key: "category.name" },
    { label: "Price", key: "price" },
    { label: "Quantity", key: "quantity" },
    { label: "Date", key: "createdAt" },
  ];
  const csvLink = {
    headers: headersTitle,
    data: filteredProducts?.map((product, index) => ({
      index: index + 1,
      name: product?.name,
      "brand.name": product?.brand?.name,
      "category.name": product?.category?.name,
      price: product?.price,
      quantity: product?.quantity,
      createdAt: new Date(product?.createdAt).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      }),
    })),
    filename: "products.csv",
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive active-projects task-table">
                  <div className="tbl-caption d-flex justify-content-between align-items-center">
                    <h4 className="heading mb-0">Products</h4>

                    <div className="d-flex align-items-center">
                      {filteredProducts?.length > 0 && (
                        <CSVLink
                          {...csvLink}
                          className="btn btn-primary light btn-sm me-2"
                          style={{
                            whiteSpace: "nowrap",
                            padding: "0.700rem 1.50rem",
                          }}
                        >
                          <i
                            className="fa-solid fa-file-excel"
                            style={{
                              alignItems: "center",
                              marginTop: "1px",
                              marginRight: "11px",
                            }}
                          />{" "}
                          Export Report
                        </CSVLink>
                      )}
                      <input
                        type="text"
                        name="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search"
                        className="form-control me-2"
                      />
                      {userInfo?.Role?.permissions?.includes(
                        "product/create"
                      ) && (
                        <Link
                          to={"create"}
                          className="btn btn-primary light btn-sm me-2"
                          style={{
                            whiteSpace: "nowrap",
                            padding: "0.700rem 1.50rem",
                          }}
                        >
                          <i className="fa-solid fa-plus me-2"></i>Add product
                        </Link>
                      )}
                    </div>
                  </div>
                  <div
                    id="task-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="empoloyeestbl2"
                      className="table ItemsCheckboxSec dataTable no-footer mb-2 mb-sm-0"
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product Name</th>
                          <th>Brand</th>
                          <th>Category</th>
                          <th>Price</th>
                          <th>Quantity</th>
                          <th>Average Cost Per Unit</th>
                          <th className="text-end">Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {records?.map((product, index) => (
                          <tr key={product?.productId}>
                            <td>{index + 1}</td>
                            <td>{product?.name}</td>
                            <td>{product?.brand?.name}</td>
                            <td>{product?.category?.name}</td>
                            <td>{product?.price}</td>
                            <td>{product?.quantity}</td>

                            <td>
                              {product?.previousPurchaseUnitPrices &&
                              product?.currentPurchaseUnitPrices
                                ? (
                                    (parseFloat(
                                      product?.previousPurchaseUnitPrices
                                    ) +
                                      parseFloat(
                                        product?.currentPurchaseUnitPrices
                                      )) /
                                    2
                                  )?.toFixed(2)
                                : product?.price}
                            </td>
                            <td className="text-end">
                              {new Date(product?.createdAt).toLocaleString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                  hour12: true, // This will format the time in AM/PM format
                                }
                              )}
                            </td>
                            <td>
                              {userInfo?.Role?.permissions?.includes(
                                "product/view/:productId"
                              ) && (
                                <span
                                  onClick={() => handleView(product)}
                                  style={{
                                    marginRight: "8px",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                >
                                  <i className="fas fa-eye" title="View"></i>
                                </span>
                              )}

                              {userInfo?.Role?.permissions?.includes(
                                "product/edit/:productId"
                              ) && (
                                <span
                                  onClick={() => handleEdit(product)}
                                  style={{
                                    marginRight: "8px",
                                    color: "green",
                                    cursor: "pointer",
                                  }}
                                >
                                  <i className="fas fa-edit" title="Edit"></i>
                                </span>
                              )}

                              {/* <span
                                onClick={() => SweetAlert(product)}
                                style={{ color: "red", cursor: "pointer" }}
                              >
                                <i className="fas fa-trash" title="Delete"></i>
                              </span> */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                      <div className="dataTables_info">
                        Showing {lastIndex - recordsPage + 1} to{" "}
                        {filteredProducts?.length < lastIndex
                          ? filteredProducts?.length
                          : lastIndex}{" "}
                        of {filteredProducts?.length} entries
                      </div>
                      <div
                        className="dataTables_paginate paging_simple_numbers justify-content-center"
                        id="example2_paginate"
                      >
                        <Link
                          className="paginate_button previous disabled"
                          to="#"
                          onClick={prePage}
                        >
                          <i className="fa-solid fa-angle-left" />
                        </Link>
                        <span>
                          {number.map((n, i) => (
                            <Link
                              className={`paginate_button ${
                                currentPage === n ? "current" : ""
                              } `}
                              key={i}
                              onClick={() => changeCPage(n)}
                            >
                              {n}
                            </Link>
                          ))}
                        </span>
                        <Link
                          className="paginate_button next"
                          to="#"
                          onClick={nextPage}
                        >
                          <i className="fa-solid fa-angle-right" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
